enum DocDetailQuery {
  PRACTICE_ID = 'pid',
  PDF_PAGE = 'page',
}

export default DocDetailQuery
